// export const COOKIE_DOMAIN = 'localhost';
export const COOKIE_DOMAIN = '.zigzag.kr';

// UTM 쿠키 설정을 제외할 경로 목록
export const UTM_COOKIE_EXCLUDED_PATHS = ['/link/bridge', '/my-page', '/auth'];

// UTM 소스별 만료 시간 (시간 단위)
export const UTM_SOURCE_EXPIRATION_HOURS: Record<string, number> = {
  // 네이버 EP: 6시간
  shopping_naver_all: 6,
  // 기본값: 24시간
  default: 24,
};

// Paid 소스 목록 (Airbridge Channel 기준)
// https://docs.google.com/spreadsheets/d/1PeXdJYn7106kw-uD-Fin0oXKvw0XyVXjWuKLG6CijT8/edit?gid=0#gid=0
export const PAID_SOURCES_ARRAY = [
  'restricted',
  'airbridge.websdk',
  'kakao_pf',
  'kakao_alram',
  'kakao_coupon',
  'kakao_custommenu',
  'growth_message',
  'affiliate_promotion',
  'affiliate',
  'raffle_promotion',
  'google.adwords',
  'facebook.business',
  'criteo_new',
  'appier',
  'apple.searchads',
  'tiktok',
  'inmobi',
  'liftoff',
  'rtbhouse',
  'tradingworks',
  'snow',
  'kakao',
  'facebook_trackinglink',
  'adison',
  'sa_naver_pc',
  'sa_naver_mo',
  'bs_naver_pc',
  'bs_naver_mo',
  'sa_google_mo',
  'sa_google_pc',
  'shopping_google_all',
  'buzzscreen',
  'linkprice',
  'remerge',
  'moloco',
  'cashfriends',
  'mobon',
  'danggen_market',
  'naver.performance_da',
  'naver.searchad',
  'shopping_naver_all',
  'toss',
  'toss-cps',
  'toss-roas',
  'youtube',
  'ce_ad_instagram',
  'ce_ad_toss',
  'ce_influencer',
  'ce_ad_seller',
  'sh_influencer',
  'sh_ad_seller',
  'mone_kakao_pf_seller',
  'bm_ad_outdoor',
  'bm_ad_influencer',
  'bm_ad_seller',
  'kkrs',
  'product_tester_promotion',
  'facebook_dynamic_coupon',
  'kakao_dynamic_coupon',
];

// Non-paid 소스 목록 (Airbridge Channel 기준)
// https://docs.google.com/spreadsheets/d/1PeXdJYn7106kw-uD-Fin0oXKvw0XyVXjWuKLG6CijT8/edit?gid=0#gid=0
export const NON_PAID_SOURCES_ARRAY = [
  'unattributed',
  'epick',
  'talklounge',
  'dailymission',
  'randombox',
  'referral',
  'social_instagram',
  'social_facebook',
  'social_youtube',
  'social_twitter',
  'social_pinterest',
  'social_snap',
  'blog',
  'sharelink',
  'user_system_link',
  'new_member',
  'web_kr_web-to-app',
  'web_to_app',
];

export const ALL_UTM_SOURCES = {
  paid: PAID_SOURCES_ARRAY,
  nonPaid: NON_PAID_SOURCES_ARRAY,
  all: [...PAID_SOURCES_ARRAY, ...NON_PAID_SOURCES_ARRAY],
};

// O(1) 조회
export const PAID_SOURCES_SET: Set<string> = new Set(PAID_SOURCES_ARRAY);
export const NON_PAID_SOURCES_SET: Set<string> = new Set(NON_PAID_SOURCES_ARRAY);
export const ALL_SOURCES_SET: Set<string> = new Set(ALL_UTM_SOURCES.all);

// 소스 타입 유틸리티 타입
export type UtmSourceType = 'paid' | 'non-paid' | 'unknown';

/**
 * UTM 소스의 타입을 반환하는 유틸리티 함수
 * @param source UTM 소스 값
 * @returns 소스 타입 ('paid' | 'non-paid' | 'unknown')
 */
export const getUtmSourceType = (source?: string): UtmSourceType => {
  if (!source) return 'unknown';

  if (PAID_SOURCES_SET.has(source)) return 'paid';
  if (NON_PAID_SOURCES_SET.has(source)) return 'non-paid';

  return 'unknown';
};
